import React, { useEffect, useState } from 'react';
import { AuthFlowProvider, AUTH_MODES } from '../../../services/Contexts/AuthFlowContext';
import AuthContainer from '../../../components/Auth/SignInReg/AuthContainer';
import { AuthBrandingProvider } from '../../../services/Contexts/AuthBrandingContext';
import { getPortalSubdomain } from '../../../utils/subdomainUtils';
import { getBranding } from '../../../services/brandingService';
import { usePublicBrandColor } from '../../../services/Contexts/BrandThemeContext';

const ResetPasswordPage = () => {
	const [branding, setBranding] = useState({});
	usePublicBrandColor(branding?.primaryColor);

	useEffect(() => {
		const subdomain = getPortalSubdomain(window.location.hostname);
		if (!subdomain) {
			setBranding({});
			return;
		}

		let isMounted = true;
		getBranding(subdomain)
			.then((response) => {
				if (isMounted) {
					setBranding(response.data);
				}
			})
			.catch(() => {
				if (isMounted) {
					setBranding({});
				}
			});

		return () => {
			isMounted = false;
		};
	}, []);

	return (
		<AuthFlowProvider initialMode={AUTH_MODES.RESET_PASSWORD}>
			<AuthBrandingProvider branding={branding}>
				<AuthContainer />
			</AuthBrandingProvider>
		</AuthFlowProvider>
	);
};

export default ResetPasswordPage;
